import { attr, hasMany, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Product = ApplicationRecord.extend({
  attrs: {
    description: attr(),
    images: hasMany({ type: 'shop-product_images' }),
    bundle_contents: hasMany({ type: 'shop-bundle_contents' }),
    product_feedbacks: hasMany({ type: 'shop-product_feedbacks' }),
    name: attr(),
    sort_order: attr({ type: Number }),
    price: attr({ type: Number }),
    price_before_discount: attr({ type: Number }),
    cost: attr({ type: Number }),
    product_type: attr({ type: String }),
    sku: attr(),
    slug: attr(),
    status: attr({ type: String }),
    in_stock: attr({ type: Boolean }),
    add_on: attr({ type: Boolean }),
    add_on_only: attr({ type: Boolean }),
    post_checkout_upsell: attr({ type: Boolean }),
    sub_descriptions: attr(), // jsonb column as array of objects.
    sub_descriptions_html: attr({ readonly: true }),
    description_html: attr({ readonly: true }),
    is_bundle: attr({ type: Boolean }),
    protein_types: attr({ type: Array }),
    spiciness_level: attr({ type: Number }),
    vat: belongsTo({ type: 'shop-vats', persist: false }),
    width_mm: attr({ type: Number }),
    height_mm: attr({ type: Number }),
    depth_mm: attr({ type: Number }),
    packing_location: attr({ type: String }),
  },
  static: {
    endpoint: '/products',
    jsonapiType: 'shop-products',
  },
});

export default Product;
